import { defineQuery, useQuery } from '@pinia/colada'
import { ref } from 'vue'
import { GetAllPositionsDTO } from '@trading/core'
import type { ID, PositionModel } from '@trading/core'

export const POSITIONS_QUERY_KEY = 'positions'
export const POSITIONS_STALE_TIME = 60_000

export function getPositionsQueryKey(accountId: ID): ['positions', ID] {
  return [POSITIONS_QUERY_KEY, accountId]
}

export function createPositionsQueryOptions(accountId: ID) {
  const { $wsPositionService } = useNuxtApp()

  return {
    key: getPositionsQueryKey(accountId),
    query: (): Promise<PositionModel[]> => {
      return $wsPositionService.getAllPositions(new GetAllPositionsDTO(accountId))
    },
    staleTime: POSITIONS_STALE_TIME
  }
}

export const usePositionsQuery = defineQuery(() => {
  const { $wsPositionService } = useNuxtApp()

  const accountId = ref<ID | null>(null)

  const query = useQuery({
    key: () => {
      if (accountId.value == null) {
        return [POSITIONS_QUERY_KEY, 'empty']
      }

      return getPositionsQueryKey(accountId.value)
    },

    enabled: () => accountId.value != null,

    query: (): Promise<PositionModel[]> => {
      if (accountId.value == null) {
        return Promise.resolve([])
      }

      return $wsPositionService.getAllPositions(new GetAllPositionsDTO(accountId.value))
    },

    staleTime: POSITIONS_STALE_TIME
  })

  return {
    ...query,
    accountId
  }
})
